import { useEffect } from "react";

import { AgentNodeData } from "src/constants/NodeDataTypes";
import { NodeEditorBaseProps } from "src/nodeEditor/NodeEditor";

type UseAgentUpdateKnownEtagProps = {
  nodeId: string;
  nodeData: AgentNodeData;
  immutable: boolean;
  isReactive: boolean;
  onUpdate: NodeEditorBaseProps<AgentNodeData>["onUpdate"];
  etag: string | undefined;
};

/**
 * Hook to keep agent_version_known_etag in sync with the actual agent version etag.
 * Used for staleness detection - when etags differ, the node may need remapping.
 *
 * Does not trigger updates when the version is immutable or reactive.
 */
export const useAgentUpdateKnownEtag = ({
  nodeId,
  nodeData,
  immutable,
  isReactive,
  onUpdate,
  etag,
}: UseAgentUpdateKnownEtagProps) => {
  useEffect(() => {
    if (
      etag &&
      nodeData.agent_version_known_etag !== etag &&
      !isReactive &&
      !immutable
    ) {
      onUpdate({
        nodeId: nodeId,
        newData: {
          ...nodeData,
          agent_version_known_etag: etag,
        },
      });
    }
  }, [etag, onUpdate, nodeData, nodeId, isReactive, immutable]);
};
